<template>
  <div>
    <BackToClientWebsiteLink
      v-if="displayBackToClientWebsiteLink"
      class="text-center pt-2 header-backtosite-mobile-fixed"
    />
    <div id="kt_header_mobile" class="header-mobile align-items-center" :class="headerClasses">
      <a href="/">
        <img alt="Logo" :src="getOrganizationLogo()" class="logo-default max-h-30px max-w-150px" />
      </a>

      <!-- Toolbar -->
      <div class="d-flex align-items-center">
        <template v-if="isDashboard">
          <!-- Aside Mobile Toggle -->
          <button
            v-if="asideEnabled"
            class="btn p-0 burger-icon rounded-0 burger-icon-left"
            id="kt_aside_mobile_toggle"
          >
            <span></span>
          </button>

          <!-- Header Menu Mobile Toggle -->
          <button
            class="btn p-0 burger-icon ml-4"
            id="kt_aside_tablet_and_mobile_toggle"
            ref="kt_aside_tablet_and_mobile_toggle"
            @click="toggleAside"
          >
            <span>
              <inline-svg src="/media/svg/icons/Text/Align-left.svg" />
            </span>
          </button>

          <!-- User Toggle -->
          <QuickUser v-if="headerUserDisplay" />
        </template>

        <QuickCart v-if="headerCartDisplay" />
      </div>
      <Aside v-if="asideEnabled" />
      <div class="aside-overlay" v-if="isOnAside" @click="closeAside"></div>
    </div>
  </div>
</template>

<script setup>
import QuickUser from "@/view/layout/extras/offcanvas/QuickUser.vue";
import QuickCart from "@/view/layout/extras/offcanvas/QuickCart.vue";
import { layoutService } from "@/core/services/layout.service";
import Aside from "@/view/layout/aside/Aside.vue";
import BackToClientWebsiteLink from "@/view/layout/header/BackToClientWebsiteLink.vue";
import { useClassesStore } from "@/core/store/config/classesStore";
import useLayoutStore from "@/core/store/layout/layoutStore";
import { storeToRefs } from "pinia";
import { useTopbar } from "@/core/composables/topbar";
import { useLayoutConfigStore } from "@/core/store/config/configStore";
import { useContainerLayout } from "@/core/composables/containerLayout";
import { isDashboardApp } from "@/core/services/domain.service";
import { computed } from "vue";

const isDashboard = isDashboardApp();

const { getClasses } = useClassesStore();

const layoutStore = useLayoutStore();
const { toggleAside, closeAside } = layoutStore;
const { isOnAside } = storeToRefs(layoutStore);

const { headerCartDisplay, headerUserDisplay } = storeToRefs(useTopbar());

const { asideEnabled } = storeToRefs(useLayoutConfigStore());

const { displayBackToClientWebsiteLink } = useContainerLayout();

const headerClasses = computed(() => {
  return [
    ...(getClasses("header_mobile") ?? []),
    ...(displayBackToClientWebsiteLink.value ? ["with-back-link"] : []),
  ].join(" ");
});

const getOrganizationLogo = () => layoutService.getOrganizationLogo();
</script>
